import { useTranslation } from 'react-i18next'
import Bredcrumb from '../../HomeMain/Bredcrumb'
import Gallery from '../../HomeMain/Gallery'

const Main = () => {
  const { t } = useTranslation()
  return (
    <>
      <Bredcrumb title={t('pages.gallery.title')} subtitle={t('pages.gallery.subtitle')} />
      <div className="gallery-block">
        <Gallery />
      </div>
    </>
  )
}

export default Main
